import { Form } from "react-final-form";
import { NotificationManager } from "react-notifications";
import { Col, Row } from "react-bootstrap";
import BMXTextField from "./.././../../../Components/Inputs/BMXTextField/BMXTextField";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import { Icon, IconButton } from "@mui/material";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";

const ChatForm = (props) => {
  const { t } = useTranslation();

  const { element: subtask, loadData } = props;

  const validate = (values) => {
    const errors = {};
    if (values.commentContent && values.commentContent.length > 500) {
      errors.commentContent = t("global:project.commentContentTooLong");
    }
    return errors;
  };

  const handleSubmit = async (values, form) => {
    const trimmedContent = values.commentContent.trim();

    if (trimmedContent.length === 0) return; // brak treści po przycięciu

    const { payload } = await GlobalAuthFetch({
      path: `/subtask/${subtask.uuid}/comment`,
      method: "POST",
      data: { commentContent: trimmedContent },
    });

    loadData();
    form.change("commentContent", "");

    const { status } = payload;
    if (status === 200) {
      NotificationManager.success(t("global:success"));
    } else {
      NotificationManager.error(t("global:error"));
    }
  };

  return (
    <Form validate={validate} validateOnBlur={true} onSubmit={handleSubmit}>
      {(formProps) => {
        const commentValue = formProps.values.commentContent || "";
        const charCount = commentValue.length;
        const maxChars = 500;

        return (
          <form
            id={props.formName}
            className="ChatForm"
            onSubmit={formProps.handleSubmit}
          >
            <div>
              <Row>
                <Col xs={10}>
                  <Field
                    name="commentContent"
                    label={t("global:project.commentContent")}
                    component={BMXTextField}
                    data-cy="commentContent"
                    multiline
                    maxRows={3}
                    style={{ marginBottom: 0 }}
                    InputProps={{ style: { marginBottom: 0 } }}
                  />
                  {/* Licznik znaków */}
                  <div
                    style={{
                      textAlign: "right",
                      fontSize: "0.85em",
                      color: charCount > maxChars ? "red" : "gray",
                    }}
                  >
                    {charCount} / {maxChars}
                  </div>
                </Col>
                <Col xs={1}>
                  <IconButton
                    style={{ marginLeft: "30px" }}
                    className="mt-3"
                    size="small"
                    type="submit"
                    disabled={
                      commentValue.trim().length === 0 || charCount > maxChars
                    }
                  >
                    <Icon
                      disabled={
                        commentValue.trim().length === 0 || charCount > maxChars
                      }
                      className="primary text"
                      fontSize={"small"}
                    >
                      send_icon
                    </Icon>
                  </IconButton>
                </Col>
              </Row>
            </div>
          </form>
        );
      }}
    </Form>
  );
};

export default ChatForm;
